import { Link } from "@tanstack/react-router"
import { toast } from "react-toastify"

export const showMovedToCollectionToast = (
  collectionName: string,
  collectionId: number,
  collectionType?: string,
) => {
  const to =
    collectionType === "noos"
      ? "/demand-planning/noos/$collectionId"
      : "/demand-planning/fashion/$collectionId"
  toast.success(
    <span>
      Variants moved to{" "}
      <Link to={to} params={{ collectionId: collectionId.toString() }} className="underline">
        {collectionName}
      </Link>
      .
    </span>,
  )
}
